import { useSelector, useDispatch } from 'react-redux';

import { useEffect } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Argon Dashboard 2 MUI components
import ArgonBox from "../../ArgonBox";
import { setLayout } from '../../../../slices/page.slice';

// Argon Dashboard 2 MUI context
//import { useArgonController, setLayout } from "context";


function PageLayout({ background, children }) {
  //const [controller, dispatch] = useArgonController();
  //const { darkMode } = controller;
  const dispatch = useDispatch();
  const page = useSelector(x => x.page);
  const darkMode  = page.darkMode;
  const { pathname } = useLocation();

  useEffect(() => {
    dispatch(setLayout("page"));
  }, [pathname]);

  return (
    <ArgonBox
      width="100vw"
      height="100%"
      minHeight="100vh"
      bgColor={darkMode ? "transparent" : background}
      sx={{ overflowX: "hidden" }}
    >
      {children}
    </ArgonBox>
  );
}

// Setting default values for the props for PageLayout
PageLayout.defaultProps = {
  background: "default",
};

// Typechecking props for the PageLayout
PageLayout.propTypes = {
  background: PropTypes.oneOf(["white", "light", "default"]),
  children: PropTypes.node.isRequired,
};

export default PageLayout;
